import { gql } from '@/__generated__';
import BlockHeader from '@/components/BlockHeader';
import { BlockContainer } from '@/components/Blocks';
import * as richTextStyles from '@/components/Blocks/BlockComponents/RichTextBlock/RichTextBlock.css';
import { createBlock } from '@/lib/parsers/blocks';

export const BREAKOUT_BOX_BLOCK_FRAGMENT = gql(`
  fragment breakoutBoxBlock on blocks_breakoutBox_BlockType {
    heading
    content: htmlContentDefault
  }
`);

const BreakoutBoxBlock = createBlock(BREAKOUT_BOX_BLOCK_FRAGMENT, ({ data, meta }) => {
  const { heading, content } = data;

  return (
    <BlockContainer
      {...{
        meta,
        marginY: true,
        customAnchor: heading,
      }}>
      <BlockHeader
        maxWidth="none"
        heading={heading}
        HeadingProps={{ variant: 'h3', color: 'black', cx: { mB: 'md' } }}
        content={content}
        ContentProps={{ className: richTextStyles.withRichText }}
      />
    </BlockContainer>
  );
});

export default BreakoutBoxBlock;
